import { ActionContext, ActionTree } from 'vuex'
import { Mutations, MutationType } from './mutations'
import { Campaign, State } from './state'
import api from '@/api'
import moment from 'moment'

export enum ActionTypes {
    GetData = 'GET_DATA',
    GetGlobalData = 'GET_GLOBAL_DATA',
    ToggleSound = 'TOGGLE_SOUND',
    RefreshReset = 'REFRESH_RESET',
    ToggleVersion = 'TOGGLE_VERSION',
    ToggleSection = 'TOGGLE_SECTION',
    ToggleCategories = 'TOGGLE_CATEGORIES'
}

type ActionAugments = Omit<ActionContext<State, State>, 'commit'> & {
    commit<K extends keyof Mutations>(
        key: K,
        payload: Parameters<Mutations[K]>[1]
    ): ReturnType<Mutations[K]>;
}

export type Actions = {
    [ActionTypes.GetData](context: ActionAugments): void;
    [ActionTypes.GetGlobalData](context: ActionAugments): void;
    [ActionTypes.ToggleSound](context: ActionAugments): void;
    [ActionTypes.RefreshReset](context: ActionAugments): void;
    [ActionTypes.ToggleVersion](context: ActionAugments, value: number[]): void;
    [ActionTypes.ToggleSection](context: ActionAugments, value: number[]): void;
    [ActionTypes.ToggleCategories](context: ActionAugments, value: string[]): void;
}

export const actions: ActionTree<State, State> & Actions = {
    async [ActionTypes.GetData]({ commit }) {
        commit(MutationType.SetLoading, true)
        let data: Campaign[] = []
        const now = new Date()
        await api.getCampaignData()
            .then((res) => {
                data = res
                    .sort((a, b) => {
                        const aTime = a.out_date.length > 0 && (new Date(a.in_date.replace(/\s/g, "T")) < now) ? a.out_date : a.in_date;
                        const bTime = b.out_date.length > 0 && (new Date(b.in_date.replace(/\s/g, "T")) < now) ? b.out_date : b.in_date;
                        // const aTime = a.in_date;
                        // const bTime = b.in_date;
                        return moment.utc(aTime).diff(moment.utc(bTime))
                    });
            })
            .catch((error) => {
                console.log("Error loading data:", error);
            })
        commit(MutationType.SetLoading, false)
        commit(MutationType.SetData, data)
    },
    async [ActionTypes.GetGlobalData]({ commit }) {
        commit(MutationType.SetLoading, true)
        let data: Campaign[] = []
        const now = new Date()
        await api.getGlobalCampaignData()
            .then((res) => {
                data = res
                    .sort((a, b) => {
                        const aTime = a.out_date.length > 0 && (new Date(a.in_date.replace(/\s/g, "T")) < now) ? a.out_date : a.in_date;
                        const bTime = b.out_date.length > 0 && (new Date(b.in_date.replace(/\s/g, "T")) < now) ? b.out_date : b.in_date;
                        // const aTime = a.in_date;
                        // const bTime = b.in_date;
                        return moment.utc(aTime).diff(moment.utc(bTime))
                    });
            })
            .catch((error) => {
                console.log("Error loading data:", error);
            })
        commit(MutationType.SetLoading, false)
        commit(MutationType.SetData, data)
    },
    async [ActionTypes.ToggleSound]({ commit, state }) {
        commit(MutationType.SetSound, !state.sound)
    },
    async [ActionTypes.ToggleVersion]({ commit }, value) {
        commit(MutationType.SetVersion, value)
    },
    async [ActionTypes.ToggleSection]({ commit }, value) {
        commit(MutationType.SetSection, value)
    },
    async [ActionTypes.ToggleCategories]({ commit }, value) {
        commit(MutationType.SetCategories, value)
    },
    async [ActionTypes.RefreshReset]({ commit }) {
        const jp = new Date()
        const gl = new Date()
        jp.setUTCHours(19, 0, 0, 0)
        gl.setUTCHours(7, 0, 0, 0)
        if (gl < new Date()) gl.setDate(gl.getDate() + 1);
        if (jp < new Date()) jp.setDate(jp.getDate() + 1);
        commit(MutationType.SetReset, [jp.toISOString(), gl.toISOString()])
    },
}